var map = {
	"./Applestore.png": "9986",
	"./Fondo.png": "5065",
	"./Grooming.png": "f6f6",
	"./KidsDog.jpg": "9be6",
	"./Logo_Petco_2021.png": "5ad3",
	"./appStore.jpeg": "e3d0",
	"./cat.png": "1f53",
	"./cat_colored.png": "d99f",
	"./club_petco.png": "66ef",
	"./dog.png": "9424",
	"./dog_colored.png": "8ca5",
	"./googlePlay.jpeg": "c958",
	"./googleplay.png": "2c78",
	"./huawei.png": "6957",
	"./images.png": "30f9",
	"./images3.jpg": "c18c",
	"./imgCita.jpg": "a8ae",
	"./logo-petco.png": "8baf",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo0.png": "a486",
	"./logo_petco_200.png": "dc4e",
	"./peb.png": "f1ea",
	"./perro.png": "1de2",
	"./perropc.png": "7a4c",
	"./petcoApp.png": "0260",
	"./shopping.png": "f70f",
	"./spa.png": "9654",
	"./success_dog.png": "ef7d",
	"./talento.jpeg": "a776",
	"./talento2.jpg": "cdff",
	"./tams.png": "c550",
	"./tienda-petco.png": "cdf8",
	"./tiendaFinal.jpg": "f9456"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";